import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import Constants from "../../../Action/Constants";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import DashboardWillMount from "../../../Middleware/Middlewares/DashboardWillMount";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { TabsComponent } from "./TabsComponent";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import Card from '@material-ui/core/Card';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import * as ReactTooltip from 'react-tooltip'
import Memo from "../../Partials/Memo/Memo";
import CreateTaskDialog from "../../Partials/Dialog/CreateTaskDialog";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import UnitServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/UnitServiceStatusTypeContainer";

class Contracts extends Component {
  protected selectedContract: ContractInterface;
  private selectedUnit: UnitInterface;
  public noteField: null;

  protected middlewares: MiddlewareInterface[] = [
    DashboardWillMount
  ];
  
  public state = {
    filter: this.props.app?.contractsFilterState,
    filterValue: this.props.app?.contractsFilterSearchState,
    anchorEl: null,
    anchorElUnits: null,
    memoPopupOpen: false,
    note: "",
    currentUnit: null,
    entity: null,
    isPromptOpen: false,
    showOnlyInactiveDeletingDialog: false,
    isCreateTasksFromActivityTemplatePopupOpen: false,
    currentActivityTemplate: null,
    currentTenant: "",
    isNewTaskPopupOpen: false,
    isSaving: false
  };

  constructor(public props) {
    super(props);
  }

  protected openMenu = (event: any, contract: ContractInterface): void => {
    this.selectedContract = contract;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public getFilteredContracts = (filter) => {
    let contracts = this.props.app.contracts.filter(contract => !contract.removed);

    switch (filter) {
      case "all":
        break;
      case "conceptExpiringEnding":
        contracts = contracts.filter((contract: ContractInterface) =>  contract.isConcept || contract.isExpiring || contract.isEnding);
        break;
      default:
        break;
    }

    return contracts;
  }

  public getContracts = () => {
    return this.searchFilterContracts()
      .sort((contract1: ContractInterface, contract2: ContractInterface) => {
        if (contract1.firstDate < contract2.firstDate) {
          return 1;
        }

        if (contract1.firstDate > contract2.firstDate) {
          return -1;
        }

        return  0;
      })
      .map((contract: ContractInterface, index: number) => {
        return (
          <TableRow
            hover
            key={index}
            className={`clickable-entity`}
            onClick={() => {
              this.redirect(`/app/contract/update/${contract.id}/0`);
            }}
          >
            <TableCell style={{width: "24px", paddingLeft: "24px", paddingRight: "0px"}}>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px"}}>
                <div
                  className="icon icon-ic-contract"
                  style={{
                    color: "#00BCD4"
                  }}
                >
                </div>
              </div>
            </TableCell>
            <TableCell style={{width: "15%", minWidth: "100px"}}>{this.formatter.formatDate(contract.firstDate)}</TableCell>
            <TableCell style={{width: "35%"}}>{contract?.unit?.displayName}</TableCell>
            <TableCell style={{width: "35%"}}>{contract?.tenantDisplayName}</TableCell>
            <TableCell style={{width: "15%"}}>{this.trans(contract.contractStatus)}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, contract)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.selectedContract && this.selectedContract.id === contract.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => {
                      this.redirect(`/app/contract/update/${this.selectedContract.id}/0`);
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public renderTasksIcon = (unit: UnitInterface) => {
    if (unit.countOfUnfinishedTasks) {
      return (
        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
          <span
            data-tip={unit.countOfOverdueTasks ?
                        this.trans("page/unitlist-tooltip/taskicon-overdueunfinished", {
                          unfinished: unit.countOfUnfinishedTasks,
                          overdue: unit.countOfOverdueTasks
                        }) :
                        this.trans("page/unitlist-tooltip/taskicon-unfinished", {
                          unfinished: unit.countOfUnfinishedTasks
                        })
                     }
          >
            <div
              style={{color: unit.countOfOverdueTasks ? "red" : "#00BCD4"}}
              className="icon icon-ic-task"
              onClick={e => {
                e.stopPropagation();
                this.redirect(`/app/unit/update/${unit.id}/`);
              }}>
            </div>
          </span>
          <ReactTooltip place="bottom" />
        </div>
      );
    }
  }

  public getTipText = (tip: string) => {
    const tipLength = 30;

    if (tip.length > tipLength) {
      return `${tip.slice(0, tipLength)}...`;
    }

    return tip;
  }

  public renderUnitAlertIcon = (unit: UnitInterface) => {
    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <span>
          <span data-tip={this.getTipText(unit.note)}>
          <div className={`icon ${unit?.hasMemos ? "icon-ic-bookmark blue-onhover" : "icon-ic-memo"}`}
              onClick={e => {
                e.stopPropagation();
                this.openMemoPopup(unit);
              }}
            >
            </div>
          </span>
          <ReactTooltip place="bottom" />
        </span>
      </div>
    );
  }

  public openMemoPopup = (unit: UnitInterface) => {
    this.setState({
      currentUnit: unit, 
      note: unit.note, 
      memoPopupOpen: true, 
      anchorElUnits: null 
    });
  }

  protected openMenuUnits = (event: any, unit: UnitInterface): void => {
    this.selectedUnit = unit;

    this.setState({
      anchorElUnits: event.currentTarget
    });
  }

  protected closeMenuUnits = (): void => {
    this.setState({
      anchorElUnits: null
    });
  }

  public changeActiveStatus = (unit: UnitInterface) => {
    this.closeMenuUnits();

    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_UNIT_SET_ACTIVE_START,
        payload: {
          active: unit.isInactive,
          unitId: unit.id
        },
        onSuccess: () => {
          this.setState({
            isSaving: false
          });
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });
    });
  }

  protected getUnitStatus = (unitWithContractObject) => {
    const currentContract = unitWithContractObject?.contract;

    // DO NOT REMOVE (will be used in near future)
    // if (unit?.isNeedToAdjustRent) {
    //   return this.trans("increaserent-label")
    // } else 
    if (currentContract) {
      return this.trans(currentContract?.contractStatus)
    } else {
      return this.trans("empty")
    }
  }

  protected getLabelColor = (unitWithContractObject) => {
    const currentContract = unitWithContractObject?.contract;

    // DO NOT REMOVE (will be used in near future)
    // if (unit?.isNeedToAdjustRent) {
    //   return "red";
    // } else 
    if (currentContract) {
      if (currentContract.isEnding || currentContract.isExpiring) {
        return "orange";
      }

      if (currentContract.isConcept) {
        return "red";
      }
    } else {
      return "red";
    }
  }

  public comparer = (a, b) => {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }

    return 0;
  }

  public unitComparer = (a, b) => {
    return this.comparer(a?.property?.address?.formattedAddress, a=b?.property?.address?.formattedAddress) ||
      this.comparer(a?.unitNumber, b?.unitNumber);
  }

  protected getFilteredUnitWithContractObjects = () => {
    const units = Object.keys(this.props.units?.byId || {}).map((id) => this.props.units.byId[id])
      .filter((unit: UnitInterface) => (!unit.removed && (unit.isEmpty || unit.isExpiring || unit.isEnding) && UnitServiceStatusTypeContainer.pickIdFromLabel("INACTIVE") !== unit?.unitServiceStatus?.id))
      .sort(this.unitComparer);
    const filteredUnitWithContractObjects = [];

    units.forEach((unit: UnitInterface) => {
      if (unit?.isEmpty && unit?.contracts?.filter((contract: ContractInterface) => !contract.removed && contract?.isConcept)?.length === 0) {
        filteredUnitWithContractObjects.push({unit});
      } else {
        unit?.contracts?.sort((contract1: ContractInterface, contract2: ContractInterface) => {
          if (contract1.firstDate < contract2.firstDate) {
            return 1;
          }
  
          if (contract1.firstDate > contract2.firstDate) {
            return -1;
          }
  
          return  0;
        })?.forEach((contract: ContractInterface) => {
          if (contract?.isConcept || contract?.isExpiring || contract?.isEnding) {
            filteredUnitWithContractObjects.push({unit, contract});
          }
        });
      }

    })

    return filteredUnitWithContractObjects;
  }

  protected getUnits = () => {
    return this.getFilteredUnitWithContractObjects()
      .map((unitWithContractObject, index: number) => {
      const currentContract = unitWithContractObject?.contract;
      let tenantDisplayName = "";

      if (currentContract) {
        tenantDisplayName = currentContract.tenantDisplayName;
      }

      const unitRowStyles = !unitWithContractObject?.unit?.isInactive ? {} :
        {color: "rgba(0, 0, 0, 0.28)", backgroundColor: "rgba(183, 183, 183, 0.2)"};

      return (
        <TableRow
          hover
          key={index}
          className={`clickable-entity`}
          style={unitRowStyles}
          onClick={() => {
            if (unitWithContractObject?.contract) {
              this.redirect(`/app/contract/update/${unitWithContractObject?.contract?.id}`);
            } else {
              this.props.dispatch({
                type: Constants.PAGE_UNIT_UPDATE_SWITCH_TAB,
                payload: {
                  index: 2,
                  unitId: unitWithContractObject?.unit?.id
                }
              });
  
              this.redirect(`/app/unit/update/${unitWithContractObject?.unit?.id}`);
            }
          }}
        >
          <TableCell style={{width: "5%"}}>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", width: "40px", marginBottom: "2px"}}>
              {unitWithContractObject?.unit?.renderAvatar()}
            </div>
          </TableCell>
          <TableCell style={{width: "35%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>{`${unitWithContractObject?.unit?.displayName}`}</TableCell>
          <TableCell style={{width: "25%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>{tenantDisplayName || ""}</TableCell>
          <TableCell style={{width: "15%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>
            {this.getUnitStatus(unitWithContractObject) &&
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >     
                <div className={`list-label creation-type-label ${this.getLabelColor(unitWithContractObject)}`} style={{minWidth: "60px"}}>
                  {this.getUnitStatus(unitWithContractObject)}
                </div>     
              </div>
            }
          </TableCell>
          <TableCell style={{width: "10%"}}>
            {this.renderTasksIcon(unitWithContractObject?.unit)}
          </TableCell>
          <TableCell style={{width: "10%"}}>
            {this.renderUnitAlertIcon(unitWithContractObject?.unit)}
          </TableCell>
          <TableCell
            onClick={e => {
              e.stopPropagation();
            }}
            style={{width: "50px", textAlign: "right"}}
          >
            <div>
              <IconButton
                onClick={e => this.openMenuUnits(e, unitWithContractObject?.unit)}
              >
                <div className="icon icon-ic-more-vert"></div>
              </IconButton>
              <Menu
                id="simple-menu"
                anchorEl={this.state.anchorElUnits}
                open={Boolean(this.state.anchorElUnits) && this.selectedUnit && this.selectedUnit.id === unitWithContractObject?.unit.id}
                onClose={this.closeMenuUnits}
                disableAutoFocusItem={true}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left"
                }}
                getContentAnchorEl={null}
              >
                <MenuItem
                  key={`edit-btn`}
                  onClick={() => this.redirect(`/app/unit/update/${this.selectedUnit.id}`)}
                >
                  <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                </MenuItem>
                {/* <MenuItem
                  key={`add-task-btn`}
                  onClick={() => this.setState({isNewTaskPopupOpen: true})}
                >
                  <ListItemIcon><div className="icon icon-ic-task aligned"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-create-task")}</ListItemText>
                </MenuItem> */}
                <MenuItem
                  key={`add-memo-btn`}
                  onClick={() => this.openMemoPopup(this.selectedUnit)}
                >
                  <ListItemIcon><div className="icon icon-ic-memo aligned"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-open-memo")}</ListItemText>
                </MenuItem>
                <MenuItem
                  key={`delete-btn`}
                  className="delete-action"
                  onClick={() => {
                    this.setState({
                      entity: this.selectedUnit,
                      isPromptOpen: true,
                      anchorElUnits: null
                    });
                  }}
                >
                  <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                </MenuItem>
              </Menu>
            </div>
          </TableCell>
        </TableRow>
      );
    });
  }
  public saveDraft = (message) => {
    this.setState({
    note: message,
  })}

  public saveReminder = (unit: UnitInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_UNIT_UPDATE_START,
        payload: {
          id: unit && unit.id,
          unit: {
            note: this.state.note
          },
        },
        onSuccess: () => this.setState({isSaving: false, memoPopupOpen: false}),
        onError: () => {
          this.setState({isSaving: false});

          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("memo-can-not-be-longer-than-255"),
              type: "warning"
            }
          });
        }
      });
    });
  }

  public removeReminder = (unit: UnitInterface) => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_UNIT_UPDATE_START,
        payload: {
          id: unit && unit.id,
          unit: {
            note: ""
          }
        },
        onSuccess: () => this.setState({isSaving: false, memoPopupOpen: false}),
        onError: () => this.setState({isSaving: false})
      });
    });
  }

  public closePrompt = (): void => {
    this.setState({
      isPromptOpen: false
    });
  }

  public delete = (): void => {
    this.closePrompt();

    if (this.state.entity.nameOfEntity === this.trans("unit")) {
      return this.unitDelete(this.state.entity);
    }
  }

  protected unitDelete = (unit: UnitInterface) => {
    this.props.dispatch({
      type: Constants.GLOBAL_UNIT_DELETE_START,
      payload: {
        unit: unit,
        propertyId: unit.propertyId
      }
    });
  }

  public changeFilter = (event: any): void => {
    const filter: string = event.target.value;

    this.setState({
      filter: filter
    }, () => {
      this.props.dispatch({
        type: Constants.CONTRACTS_FILTER_UPDATE_STATE,
        payload: {
          filter: this.state.filter
        }
      });
    });
  }

  public setFilterValue = (event: any): void => {
    const filterValue: string = event.target.value;

    this.setState({
      filterValue: filterValue
    }, () => {
      this.props.dispatch({
        type: Constants.CONTRACTS_FILTER_SEARCH_UPDATE_STATE,
        payload: {
          filter: this.state.filterValue
        }
      });
    });
  }

  // solution to have a possibility to find entities with special symbols
  public deUmlaut(value){
    if (!value) {
      return "";
    }

    value = value.toLowerCase();
    value = value.replace(/ä/g, 'a');
    value = value.replace(/ö/g, 'o');
    value = value.replace(/ü/g, 'u');
    value = value.replace(/ß/g, 'ss');
    value = value.replace(/ /g, '-');
    value = value.replace(/\./g, '');
    value = value.replace(/,/g, '');
    value = value.replace(/\(/g, '');
    value = value.replace(/\)/g, '');

    return value;
  }

  public searchFilterContracts = () => {
    return this.getFilteredContracts(this.state.filter)
      .reduce((arr, contract) => {
        // Search by address
        if ( contract.unit
              && contract.unit.property
              && contract.unit.property.address
              && contract.unit.property.address.formattedAddress
              && contract.unit.property.address.formattedAddress.toLowerCase().includes(this.state.filterValue.toLowerCase()) === true) {
          arr.push({
            contract: contract
          });
          return arr;
        } else {
          // try to search again after deUmlaut
          if (this.deUmlaut(contract.unit
                && contract.unit.property
                && contract.unit.property.address
                && contract.unit.property.address.formattedAddress).toLowerCase().includes(this.state.filterValue.toLowerCase()) === true) {
            arr.push({
              contract: contract
            });
            return arr;
          }
        }

        // Search by unitNumber
        if (contract.unit && contract.unit.unitNumber && contract.unit.unitNumber.toLowerCase().includes(this.state.filterValue.toLowerCase()) === true) {
          arr.push({
            contract: contract
          });
          return arr;
        }

        // Search by person displayname
        if (contract.tenantDisplayName.toLowerCase().includes(this.state.filterValue.toLowerCase()) === true) {
          arr.push({
            contract: contract
          });
          return arr;
        } else {
          // try to search again after deUmlaut
          if (this.deUmlaut(contract.tenantDisplayName).toLowerCase().includes(this.state.filterValue.toLowerCase()) === true) {
            arr.push({
              contract: contract
            });
            return arr;
          } else {
            // try to change word positions
            let stringArr = this.state.filterValue.toLocaleLowerCase().split(" ");
            stringArr = stringArr.map((string, index) => {
              if (index !== stringArr.length - 1) {
                return string + " ";
              }

              else {
                return string;
              };
            });

            let isIncluded = true;

            stringArr.forEach(string => {
              if (!((contract.tenantDisplayName.toLowerCase() + " ").includes(string))) {
                isIncluded = false;
              }
            })

            if (isIncluded) {
              arr.push({
                contract: contract
              });
              return arr;
            } else {
              let isIncluded = true;

              stringArr.forEach(string => {
                if (!((this.deUmlaut(contract?.tenantDisplayName).toLowerCase() + " ").includes(string))) {
                  isIncluded = false;
                }
              })

              if (isIncluded) {
                arr.push({
                  contract: contract
                });
                return arr;
              }
            }
          }
        }

        return arr;
      }, [])
      .map(res => res.contract);
  }

  public render() {
    return (
      <div className="state-app">
        <div className={`box box-full component-dashboard has-general-page-header with-tabs bottom-whitespace ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <h1>{this.trans("title-dashboard")}</h1>
            <TabsComponent
              activeTab={5}
              {...this.props}
            />
          </div>

          <div className="component-wrapper no-margin-top">
            <div className="component">
              <Card className="card expiring-contracts">
                <div className="label-container"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    height: "48px",
                    maxHeight: "48px"
                  }}
                >
                  <h3 className="card-title" style={{flexDirection: "column", display: "flex"}}>
                    {this.trans("contracts")}
                    <h4 className="dashboard-subtitle">{this.trans("dashboard-contracts/subtitle")}</h4>
                  </h3>
                </div>
                <div>
                  {/* <TableComponent
                    {...this.props}
                    paginator={{
                      name: "DashboardContracts",
                      path: this.props.app.paginator
                    }}
                    headers={[
                      "", this.trans("date"), this.trans("unit"), this.trans("tenant"), this.trans("status"), ""
                    ]}
                    rows={this.getContracts()}
                    entities={this.props.app.contracts}
                    className="listing-table tasks-listing-table with-first-border"
                    subtitle={this.trans("title-no-contracts-to-list")}
                  /> */}
                  <TableComponent
                    {...this.props}
                    paginator={{
                      name: "UnitsDashboard",
                      path: this.props.app.paginator
                    }}
                    headers={[
                      "", this.trans("unit"), this.trans("tenant"), this.trans("status"), "", ""
                    ]}
                    entities={Object.keys(this.props.units?.byId || {}).map((id) => this.props.units.byId[id]).filter((unit: UnitInterface) => unit.isEmpty || unit.isExpiring || unit.isEnding)}
                    className="listing-table dashboard-unpaid-listing-table with-first-border"
                    subtitle={this.trans("title-property-no-units-to-list")}
                    rows={this.getUnits()}
                  />
                </div>
              </Card>

              <PromptDialog
                {...this.props}
                title={this.trans("memo")}
                content={
                  <div>
                    <Memo 
                      {...this.props}
                      relations={{ unitId: this.state.currentUnit?.id }}
                      entity={this.state.currentUnit}
                saveDraft={this.saveDraft}
                    />
                  </div>
                }
                prioritizeClosing={true}
                openLeavePrompt={this.state.memoPopupOpen}
                onlyPositiveButton={true}
                positiveButtonLabel={this.trans("button-close")}
                onSave={() => this.saveReminder(this.state.currentUnit)}
                hideCross={true}
                subtitle={this.state.currentUnit && this.state.currentUnit.displayName ?
                  this.state.currentUnit?.displayName : ""}
              />

              <DeleteEntityPrompt
                {...this.props}
                isOpen={this.state.isPromptOpen}
                onCancel={this.closePrompt}
                onDelete={this.delete}
              />

              <PromptDialog
                {...this.props}
                title={this.trans("create-tasks-for", {activityTemplate: this.state.currentActivityTemplate ? this.state.currentActivityTemplate.name : ""})}
                content={this.trans("you-are-about-to-create-task-for-activity-for-unit", {activityTemplate: this.state.currentActivityTemplate ? this.state.currentActivityTemplate.name : "", tenant: this.state.currentTenant, unit: this.state.currentUnit && this.state.currentUnit.displayName ? this.state.currentUnit.displayName : ""})}
                openLeavePrompt={this.state.isCreateTasksFromActivityTemplatePopupOpen}
                negativeButtonLabel={this.trans("button-cancel")}
                positiveButtonLabel={this.trans("create-tasks")}
                prioritizeClosing={true}
                onDiscard={() => { this.setState({ isCreateTasksFromActivityTemplatePopupOpen: false }); }}
                onSave={() => { this.setState({ isCreateTasksFromActivityTemplatePopupOpen: false }, () => {
                  this.props.dispatch({
                    type: Constants.PAGE_ACTIVITY_CREATE_ADD_PARAMS,
                    payload: {
                      unitId: this.state.currentUnit && this.state.currentUnit.id
                    }
                  });
                  this.redirect(`/app/activity/create/${this.state.currentActivityTemplate && this.state.currentActivityTemplate.id}/0/${this.state.currentUnit && this.state.currentUnit.id}`);
                })}}
                hideCross={true}
              />

              <CreateTaskDialog 
                {...this.props}
                entity={this.selectedUnit}
                isOpen={this.state.isNewTaskPopupOpen}

                closeDialog={() => {
                  this.setState({
                    isNewTaskPopupOpen: false,
                    isSaving: false, 
                    anchorEl: null
                  })
                }}
              />

              <PageTransition isSaving={this.state.isSaving} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    units: state.units,
    events: state.events,
    tasks: state.tasks,
    component: state.expiringContracts,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(Contracts);
